import { GenericCard } from '~src/app/spaces/CardView/GenericCard';
import { Messages } from '~src/codegen/Localize';
import { ExplorableItemDefinition, ContentTypeFilterClause } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { CustomViewsContentType } from '~src/ts/models/ContentTypes';
import { CustomViews } from '~src/ts/ServerApi/CustomViews/CustomViews';

import { getGenericDefaultFilters } from './getDefaultFilters';

export const CustomViewDefinition: ExplorableItemDefinition = {
  itemType: 'customView',
  pluralName: Messages.customViews,
  singularName: Messages.customView,
  emptyStateMessage: Messages.workbooksCustomViewsEmptyMessage,
  contentFilterKeys: CustomViewsContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['customView']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return CustomViews.all().withExtraParams(CustomViewsContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
